<template>
  <div id="app">
    <v-app id="inspire">

      <m-pay-message type="error"
                     :value="$store.getters.errorMessage"
                     :trigger="$store.getters.errorMessageTrigger">
        {{ $store.getters.errorMessage }}
      </m-pay-message>
      <m-pay-message type="success"
                     :value="$store.getters.successMessage"
                     :trigger="$store.getters.successMessageTrigger">
        {{ $store.getters.successMessage }}
      </m-pay-message>
      <m-pay-message type="info"
                     :value="$store.getters.infoMessage"
                     :trigger="$store.getters.infoMessageTrigger">
        {{ $store.getters.infoMessage }}
      </m-pay-message>
      <m-pay-message type="warning"
                     :value="$store.getters.warningMessage"
                     :trigger="$store.getters.warningMessageTrigger">
        {{ $store.getters.warningMessage }}
      </m-pay-message>
      <m-pay-error-dialog
        :error="$store.getters.error"
        :trigger="$store.getters.errorTrigger"
      />

      <v-navigation-drawer
        fixed
        clipped
        absolute
        class="grey lighten-4"
        app
        v-model="drawer"
      >
        <v-list
          dense
          class="grey lighten-4"
        >
          <template v-for="(item, i) in availableItems">
            <v-layout
              row
              v-if="item.heading"
              align-center
              :key="i"
            >
              <v-flex xs7>
                <v-subheader v-if="item.heading">
                  {{ item.heading }}
                </v-subheader>
              </v-flex>
            </v-layout>
            <v-divider
              dark
              v-else-if="item.divider"
              class="my-3"
              :key="i"
            ></v-divider>
            <router-link v-else :key="i"
                         tag="v-list-tile"
                         :to="{ name: item.linkName }">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="grey--text">
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </router-link>
          </template>
        </v-list>
      </v-navigation-drawer>

      <v-toolbar color="primary" app absolute clipped-left>
        <v-toolbar-side-icon @click.native="drawer = !drawer" color="white"></v-toolbar-side-icon>
        <img class="ml-2 mr-1" src="/static/img/klix-logo-dark-green.svg" width="36px" height="36px"
             style="background-color: white; border-radius: 50%; padding: 3px;"/>
        <span class="title ml-1 mr-3 font-weight-bold" style="color: white;">
          <span class="font-weight-medium ml-1">Merchant Console</span>
        </span>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="profileDialog"
          hide-overlay
          no-click-animation
          transition="none"
          origin="top right"
          width="400"
          content-class="layout__user-profile__dialog"
        >
          <v-avatar size="30" slot="activator">
            <img v-if="currentUserAvatar" :src="currentUserAvatar" :alt="currentUser">
            <v-icon v-if="!currentUserAvatar" dark x-large
                    style="background-color: #00BCD4; font-size:40px;">account_circle</v-icon>
          </v-avatar>

          <v-card v-if="profileDialog">
            <v-card-title
              class="headline lighten-2"
              primary-title
            >
              <v-layout row>
                <v-avatar size="90" class="ml-3 mr-4">
                  <img v-if="currentUserAvatar" :src="currentUserAvatar" :alt="currentUser">
                  <i v-if="!currentUserAvatar"
                     class="material-icons"
                     style="font-size: 96px; color: lightgrey;">
                    account_circle
                  </i>
                </v-avatar>
                <div>
                  <div class="text-truncate title grey--text text--darken-3">
                    {{ currentUserName }}
                  </div>
                  <div class="text-truncate subheading grey--text text-lowercase">
                    {{ currentUser }}
                  </div>
                  <v-btn small color="secondary" class="ml-0 text-capitalize"
                         v-if="currentUser" @click="openAccount">
                    Klix Account
                  </v-btn>
                </div>
              </v-layout>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="text-capitalize"
                color="secondary"
                flat
                @click="logout"
              >
                Sign&nbsp;<span class="text-lowercase">out</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-toolbar>
      <v-content>
        <MPayShutdownAnnouncement />
        <v-container fluid v-if="mainContentAvailable" class="px-2">
          <v-card-actions v-if="showBreadcrumbs" style="min-height: 28px;"
                          class="breadcrumbs__container px-2 mb-3">
            <span v-for="breadcrumb in breadcrumbs" :key="breadcrumb.text">
              <span v-if="breadcrumb.disabled"
                    class="title">{{ breadcrumb.text }}
              </span>
              <template v-else>
                <router-link class="v-breadcrumbs__item" style="display: inline;"
                             :to="breadcrumb.to">
                  <span class="title">{{ breadcrumb.text }}</span>
                </router-link>
                <v-icon size="20px" style="display: inline">chevron_right</v-icon>
              </template>
            </span>

            <v-spacer></v-spacer>
            <span class="navigation__links">
              <slot name="links"></slot>
            </span>
          </v-card-actions>

          <slot/>
        </v-container>
        <div v-if="unauthorizedMessageAvailable" class="ml-5 mt-4">
          <h2>You are not allowed to see this page.</h2>
          <h3>Please contact administrator.</h3>
        </div>
      </v-content>

      <v-footer color="primary" class="white--text" app>
        <img class="ml-3 mr-2" src="/static/img/klix-logo-dark-green.svg" width="27px" height="27px"
             style="background-color: white; border-radius: 50%; padding: 2px;"/>
        <v-spacer></v-spacer>
        <span class="mr-1">Copyright &copy; 2019</span>
        <img class="ml-1 mr-3" src="/static/img/citadele-logo-original.png" height="75%"
             style="border-radius: 10%;"/>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import startCase from 'lodash.startcase';
import routes from '../router/routes-mc';
import Roles from '../../utils/user-roles';
import MPayErrorMessage from '../../components/MPayErrorMessage';
import MPayErrorDialog from '../../components/MPayErrorDialog';
import MPayMessage from '../../components/MPayMessage';
import MPayRoot from '../../components/MPayRoot';
import MPayShutdownAnnouncement from '../../components/MPayShutdownAnnouncement';

export default {
  name: 'MPayLayoutMc',
  components: { MPayMessage,
    MPayErrorMessage,
    MPayErrorDialog,
    MPayRoot,
    MPayShutdownAnnouncement },
  props: {
    source: String,
  },
  data: () => ({
    drawer: true,
    drawerRight: true,
    right: null,
    left: null,
    profileDialog: false,
    items: [
      { icon: 'insert_chart_outlined', text: 'Dashboard', linkName: 'business-days', roles: [Roles.READ_MERCHANT_TRANSACTION] },
      { divider: true },
      { heading: 'Payment Information', roles: [Roles.READ_MERCHANT_PURCHASE, Roles.READ_MERCHANT_TRANSACTION] },
      { icon: 'playlist_add_check', text: 'Transactions', linkName: 'transactions', roles: [Roles.READ_MERCHANT_TRANSACTION] },
      { icon: 'autorenew', text: 'Recurring Payments', linkName: 'recurring', roles: [Roles.READ_MERCHANT_PURCHASE] },
      { icon: 'create', text: 'Orders', linkName: 'orders', roles: [Roles.READ_MERCHANT_ORDER] },
      { divider: true },
      { heading: 'Settings', roles: [Roles.READ_MERCHANT_PURCHASE, Roles.READ_MERCHANT_TRANSACTION] },
      { icon: 'people_outlined', text: 'Employees', linkName: 'merchant-employees' },
      { icon: 'local_shipping', text: 'Shipping Methods', linkName: 'shipping-methods', roles: [Roles.READ_MERCHANT_SHIPPING_METHOD] },
      { icon: 'widgets', text: 'Widgets', linkName: 'widgets', roles: [Roles.READ_MERCHANT_WIDGET] },
      { icon: 'settings', text: 'Business Profile', linkName: 'merchant' },
      { divider: true },
      { heading: 'Developers' },
      { icon: 'lock', text: 'Certificates', linkName: 'certs', roles: [Roles.READ_MERCHANT_CERTIFICATE] },
      { icon: 'repeat', text: 'Exchange Logs', linkName: 'exchange-logs', roles: [Roles.READ_MERCHANT_PURCHASE] },
      { icon: 'help', text: 'Integration Documentation', linkName: 'documentation' },
    ],
  }),
  computed: {
    currentUser() {
      return this.$store.getters.user ? this.$store.getters.user.email : false;
    },
    currentUserAvatar() {
      return this.$store.getters.userAvatar;
    },
    currentUserName() {
      if (!this.currentUser) {
        return '';
      }
      return `${this.$store.getters.user.firstName} ${this.$store.getters.user.lastName}`;
    },
    availableItems() {
      return this.items.filter((item) => {
        if (item.roles) {
          return this.$store.getters.hasAnyRole(item.roles);
        }
        return true;
      });
    },
    isAuthorized() {
      if (!this.$route.meta.roles) {
        return true;
      }
      if (!this.$store.getters.user) {
        return false;
      }
      return this.$store.getters.hasAnyRole(this.$route.meta.roles);
    },
    mainContentAvailable() {
      return this.isAuthorized;
    },
    unauthorizedMessageAvailable() {
      return this.$store.getters.user && !this.isAuthorized;
    },
    showBreadcrumbs() {
      return this.$route.meta.breadcrumbs || this.$route.meta.title;
    },
    breadcrumbs() {
      const routeTitle = (name) => {
        const title = routes.filter(r => r.name === name)[0].meta.title;
        return title || startCase(name);
      };
      let breadcrumbs = [];
      if (this.$route.meta.breadcrumbs) {
        breadcrumbs = this.$route.meta.breadcrumbs.map((b) => {
          const text = routeTitle(b.name);
          const to = { name: b.name };
          if (b.param) {
            to.params = {};
            to.params[b.param] = this.$route.params[b.param];
          }
          return { text, to, disabled: false };
        });
      }
      const currentPage = routeTitle(this.$route.name);
      breadcrumbs.push({ text: currentPage, disabled: true });
      return breadcrumbs;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    openAccount() {
      this.profileDialog = false;
      this.$router.push({ name: 'profile' });
    },
  },
  created() {
    if (!this.$store.getters.user) {
      this.$store.dispatch('fetchUser');
    }
  },
};
</script>

<style>
  .text {
    font-weight: 400;
  }

  .router-link-exact-active {
    border-right: solid 10px #00BCD4;
  }

  .router-link-active a div div,
  .router-link-active a div i {
    font-size: 1.25em;
    color: #00BCD4 !important;
  }

  .navigation__links a {
    text-decoration: none;
  }

  .breadcrumbs__container {
    padding: 0;
  }

  .layout__user-profile__dialog.v-dialog {
    box-shadow: none;
    transition: none;
  }

  .layout__user-profile__dialog.v-dialog--active {
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, .2),
    0 24px 38px 3px rgba(0, 0, 0, .14),
    0 9px 46px 8px rgba(0, 0, 0, .12);
    transition: none;
    position: fixed;
    right: 0;
    top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/mc/components/MPayLayoutMc.vue